// extracted by mini-css-extract-plugin
export default {"services_contact":"services_services_contact__mSaj2"};